import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Formik, useFormikContext } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import InputForm from '../../../../components/InputForm/InputForm'
import SelectorField from '../../../../components/Selector/SelectorField'
import TableLocal from '../../../../components/Table/TableLocal/TableLocal'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import { numberFormat } from '../../../../utils/formats/formats'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRefillContext } from '../../../../utils/hooks/Context/RefillContext'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../../utils/theme/styles'
import useShowDetails from '../../hooks/useShowDetails'
import useOrder from './../../../../utils/hooks/useOrder/useOrder'
import IconHeader from './../../../../components/Table/TableCells/IconHeader/IconHeader'
import {
  sortDniASC,
  sortDniDSC,
  sorting,
  sortLastnameASC,
  sortLastnameDSC,
  sortNameASC,
  sortNameDSC,
  sortOnlyNameASC,
  sortOnlyNameDSC,
} from '../../../../utils/formats/sorters'

const columns = [
  {
    Header: 'Número de bolsillo',
    accessor: 'sTarjeta',
    type: 'card',
    toEnd: true,
  },
  {
    label: 'Rut colaborador	',
    Header: IconHeader,
    accessor: 'sRut',
    type: 'dni',
    sortBy: 'RUT',
  },
  {
    label: 'Nombre',
    Header: IconHeader,
    accessor: 'sSoloNombre',
    sortBy: 'SOLONOMBRE',
  },
  {
    label: 'Apellidos',
    Header: IconHeader,
    accessor: 'sApellidos',
    sortBy: 'APELLIDOS',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Monto',
    accessor: 'nMonto',
    editable: true,
    type: 'currency',
  },
]
const employeeTypeOptions = [
  {
    id: 'PE',
    value: 'PE',
    label: 'Solo a cuentas nominativas',
  },
  {
    id: 'FI',
    value: 'FI',
    label: 'Solo a cuentas no nominativas',
  },
]

function Individual() {
  const { texts } = useLabels()
  const { showDetails, boxRef, onShowAmount } = useShowDetails()
  const { values } = useFormikContext()
  const employees = useRef([])
  const [filterText, setFilterText] = useState('')
  const [heigth, setHeigth] = useState(200)
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const {
    cEmpleados,
    totalAmount,
    setCEmpleados,
    cEmpleadosLocalFilter,
    setCEmpleadosLocalFilter,
    handleChangeEmployeeData,
  } = useRefillContext()

  const { orderAsc, orderBy, onSort } = useOrder()

  useEffect(() => {
    if (cEmpleados.length > 0) {
      const copy = [...cEmpleados]
      setTimeout(() => {
        if (orderBy === 'NOMBRE' && orderAsc) {
          setCEmpleados(sorting([...copy], sortNameASC))
        } else if (orderBy === 'NOMBRE' && !orderAsc) {
          setCEmpleados(sorting([...copy], sortNameDSC))
        } else if (orderBy === 'SOLONOMBRE' && orderAsc) {
          setCEmpleados(sorting([...copy], sortOnlyNameASC))
        } else if (orderBy === 'SOLONOMBRE' && !orderAsc) {
          setCEmpleados(sorting([...copy], sortOnlyNameDSC))
        } else if (orderBy === 'APELLIDOS' && orderAsc) {
          setCEmpleados(sorting([...copy], sortLastnameASC))
        } else if (orderBy === 'APELLIDOS' && !orderAsc) {
          setCEmpleados(sorting([...copy], sortLastnameDSC))
        } else if (orderBy === 'RUT' && orderAsc) {
          setCEmpleados(sorting([...copy], sortDniASC))
        } else if (orderBy === 'RUT' && !orderAsc) {
          setCEmpleados(sorting([...copy], sortDniDSC))
        } else if (orderBy === '') {
          setCEmpleados([...cEmpleados])
        }
      }, 50)
    }
  }, [orderBy, orderAsc])

  const handleSearchEmployee = async (submitValues) => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.refills
      .caculateRecharge({
        ...submitValues,
        sBusqueda:
          typeof submitValues.sBusqueda === 'string'
            ? submitValues.sBusqueda
                .replaceAll('.', '')
                .replaceAll('-', '')
                .trim()
            : '',
        sSucursal: values.sSucursal,
        sCentroCosto: values.sCentroCosto,
        bAsc: orderAsc,
        sOrderby: orderBy,
      })
      .then((res) => {
        // Compara resultado de la búsqueda con los empleados a los cuales ya se les asignó monto y setea monto modificado
        const arrBusqueda = res.data.cEmpleados

        cEmpleados &&
          cEmpleados.map((element) => {
            arrBusqueda.find((item) => {
              if (item.sEmpleado === element.sEmpleado) {
                item.nMonto = element.nMonto
              }
            })
          })

        employees.current = res.data.cEmpleados

        setCEmpleados(res.data.cEmpleados)
        setCEmpleadosLocalFilter(res.data.cEmpleados)

        return res
      })
      .catch(() => {
        setCEmpleados([{}])
        setCEmpleadosLocalFilter([{}])
      })
    setHeigth(700)
    handleCLoseLoading()
    if (!showDetails) {
      onShowAmount()
    }
  }

  const handlerFilter = (text) => {
    setFilterText(text)

    if (!text) {
      setCEmpleadosLocalFilter(cEmpleados)
    }

    setCEmpleadosLocalFilter(() => {
      const result = cEmpleados.filter((item) =>
        Object.values(item).some(
          (valor) =>
            String(valor).toLowerCase().includes(text.toLowerCase()) ||
            String(valor)
              .toLowerCase()
              .includes(
                text.toLowerCase().replaceAll('.', '').replaceAll('-', ''),
              ),
        ),
      )

      return result
    })
  }

  return (
    <Formik
      initialValues={{
        nMonto: '',
        sTipoEmpleado: null,
        sBusqueda: '',
        sEmpresa: values.sEmpresa,
      }}
      onSubmit={handleSearchEmployee}
      validate={(actualValues) => {
        const errors = {}
        if (!actualValues.nMonto) {
          errors.nMonto = 'Debes seleccionar un monto'
        }
        return errors
      }}
    >
      {({
        values: actualValues,
        errors,
        handleSubmit,
        handleChange,
        setFieldValue,
        isValid,
      }) => (
        <Flex direction="column" maxH={heigth}>
          <UnderlineHeading variant="h5">
            {texts.calculate_by_business_days}
          </UnderlineHeading>
          <Box mt="21px">
            <HStack alignItems="center" spacing="60px" w="100%">
              <VStack alignItems="flex-start">
                <Text variant="overline">{texts.amount_per_colaborator}</Text>
                <Input
                  name="nMonto"
                  id="nMonto"
                  onChange={handleChange}
                  onFocus={() => {
                    setFieldValue(
                      'nMonto',
                      numberFormat(actualValues.nMonto, 'number'),
                    )
                  }}
                  onBlur={() => {
                    setFieldValue(
                      'nMonto',
                      numberFormat(actualValues.nMonto, 'currency'),
                    )
                  }}
                  value={actualValues.nMonto}
                  placeholder="0.00"
                />
              </VStack>
              <VStack alignItems="flex-start" spacing="32px" mt="79px" w="30%">
                <SelectorField
                  name="sTipoEmpleado"
                  id="sTipoEmpleado"
                  value={
                    actualValues.sTipoEmpleado || employeeTypeOptions[0].id
                  }
                  // defaultValue={employeeTypeOptions[0]?.id}
                  title={texts.recharge_to}
                  isClearable
                  placeholder="Todas las cuentas"
                  titleType="overline"
                  options={employeeTypeOptions}
                />
              </VStack>
              <Box alignSelf="flex-end">
                <Button
                  padding="4px 16px"
                  width="135px"
                  height="32px"
                  disabled={!isValid}
                  onClick={errors.nMonto ? () => null : handleSubmit}
                  variant={errors.nMonto ? 'gray' : 'black'}
                >
                  <Text
                    variant="button13"
                    color={errors.nMonto ? colors.gray[900] : 'FFFFFF'}
                  >
                    {texts.calculate_amount}
                  </Text>
                </Button>
              </Box>
            </HStack>
          </Box>
          {(showDetails || cEmpleados[0]?.sEmpleado) && (
            <VStack>
              <Box ref={boxRef} mt="40px">
                <HStack alignItems="baseline">
                  <Heading variant="h4" lineHeight="30px" fontWeight={400}>
                    {texts.calculated_amount}
                  </Heading>
                  :
                  <Heading variant="h4" color="#000000" lineHeight="30px">
                    ${Number(totalAmount).toLocaleString('gb-GB')}
                  </Heading>
                </HStack>
              </Box>
              <VStack w="100%" alignItems="flex-start">
                <HStack alignItems={'flex-end'} spacing="16px">
                  <InputForm
                    onChange={(event) => {
                      handlerFilter(event.target.value)
                    }}
                    value={filterText}
                    icon={faSearch}
                    placeholder="Buscar colaborador"
                    onClear={() => {
                      handlerFilter('')
                    }}
                  />
                  <Box>
                    <Button
                      w="70px"
                      border="transparent"
                      onClick={errors.nMonto ? () => null : handleSubmit}
                      variant={errors.nMonto ? 'black' : 'primary'}
                    >
                      <Text color="white" variant="button">
                        Buscar
                      </Text>
                    </Button>
                  </Box>
                </HStack>
                <Box w="100%">
                  <TableLocal
                    key={cEmpleadosLocalFilter}
                    pagination={{
                      actualPage: 1,
                    }}
                    onSort={onSort}
                    orderBy={orderBy}
                    columns={columns}
                    orderAsc={orderAsc}
                    updateMyData={handleChangeEmployeeData}
                    data={
                      cEmpleados.length !== cEmpleadosLocalFilter.length
                        ? cEmpleadosLocalFilter
                        : cEmpleados
                    }
                  />
                </Box>
              </VStack>
            </VStack>
          )}
        </Flex>
      )}
    </Formik>
  )
}

export default Individual
